import React from 'react';
import { Area, AreaChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import CmtCard from '../../../@coremat/CmtCard';
import CmtCardHeader from '../../../@coremat/CmtCard/CmtCardHeader';
import CmtCardContent from '../../../@coremat/CmtCard/CmtCardContent';
import { makeStyles } from '@material-ui/core/styles';
import { formatCurrency } from './utils/formatDashboard';
import Skeleton from '@material-ui/lab/Skeleton';

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    height: '100%',
  },
}));

const VolumeStatsSection = ({ volume, loading }) => {
  const classes = useStyles();

  const chartData = volume
    ? [
        { name: 'Total Credited', value: volume.totalCredited },
        { name: 'Total Debited', value: volume.totalDebited },
        { name: 'Net Volume', value: volume.netVolume },
        { name: 'Last 7 Days', value: volume.last7DaysVolume },
        { name: 'Last 30 Days', value: volume.last30DaysVolume },
      ]
    : [];

  return (
    <CmtCard className={classes.cardRoot}>
      <CmtCardHeader title="Volume Statistics" />
      <CmtCardContent>
        {loading ? (
          <Skeleton variant="rect" height={200} />
        ) : (
          <ResponsiveContainer width="100%" height={200}>
            <AreaChart data={chartData} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
              <defs>
                <linearGradient id="volumeGradient" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#5BA6D9" stopOpacity={1} />
                  <stop offset="95%" stopColor="#5BA6D9" stopOpacity={0.2} />
                </linearGradient>
              </defs>
              <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ fontSize: 11 }} />
              <YAxis axisLine={false} tickLine={false} tick={{ fontSize: 11 }} tickFormatter={formatCurrency} />
              <Tooltip formatter={(v) => formatCurrency(v)} labelStyle={{ color: '#333' }} />
              <Area type="monotone" dataKey="value" stroke="#5BA6D9" fill="url(#volumeGradient)" strokeWidth={2} />
            </AreaChart>
          </ResponsiveContainer>
        )}
      </CmtCardContent>
    </CmtCard>
  );
};

export default VolumeStatsSection;
